<template>
  <el-dialog :title="title" :visible.sync="visible" :before-close="closeDialog" @closed="closeDialog" width="85%" @open="addOpen" :close-on-click-modal="false">
    <el-card>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-input placeholder="请输入标题" style="width: 350px;" v-model="param.keywords" clearable @clear="search">
            <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
          </el-input>
        </el-col>
      </el-row>
      <el-table :data="list" stripe border :cell-style="{ textAlign: 'center' }">
        <el-table-column prop="id" label="ID" align="center" width="60px"></el-table-column>
        <el-table-column prop="pic" label="图片" align="center" width="200px">
          <template slot-scope="scope">
            <el-image v-if="scope.row.pic!=''" :src="scope.row.pic+'?imageView2/2/w/75'"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="标题" align="center">
          <template slot-scope="scope">
            <a :href="scope.row.url" target="_blank">{{scope.row.title}}</a>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" align="center" width="200px">
          <template slot-scope="scope">
            {{scope.row.create_time | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100px">
          <template slot-scope="scope">
            <el-button type="success" icon="el-icon-edit" size="mini" @click="add(scope.row.id)">添加</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="param.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="param.count"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-card>
  </el-dialog>
</template>

<script>
export default {
  name: 'content_classical_add',
  props: [
    'visible'
  ],
  data () {
    return {
      title: '添加经典文章',
      list: [],
      total: 0,
      pageTotal: 1,
      param: {
        type: [10],
        keywords: '',
        page: 1,
        count: 10
      }
    }
  },
  methods: {
    closeDialog () {
      this.param = {
        type: [10],
        keywords: '',
        page: 1,
        count: 10
      }
      this.$emit('close')
    },
    addOpen () {
      this.getList()
    },
    search () {
      this.param.page = 1
      this.getList()
    },
    async getList () {
      const res = await this.$http.get('/admin/content/list', this.param)
      if (res.code === 0) {
        this.list = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async add (id) {
      const res = await this.$http.post('/admin/content/add_to_classical', { id: id })
      if (res.code === 0) {
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    }
  }
}
</script>

<style>
</style>
